import queryCurrentUser from '@ms/yammer-graphql/dist/operations/queryCurrentUser.graphql';

const apiName = 'CurrentUserClients';

const apiRequestBody = {
  operationName: apiName,
  query: queryCurrentUser,
};

export const getCacheKey = (): string => apiName.concat(JSON.stringify(apiRequestBody));
